module.exports = __webpack_public_path__ + "static/media/短线挖掘@2x.588b0c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/短线挖掘@2x.png
// module id = 1567
// module chunks = 0